module.exports = require('./helpers/bundle-url').getBundleURL('hdhZv') + "teak-haven-abstract-balmoral-0.88f1471d.jpg";